// When the minus button is pressed on a cart item with quantity 1,
// remove the line instead of bouncing off the input's data-min.
// Delegated + capture phase so we run before QuantityInput's stepDown.
(() => {
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.cart-item .quantity__button[name="minus"]');
      if (!button) return;

      const input = button.parentElement && button.parentElement.querySelector('input.quantity__input');
      if (!input) return;

      if (parseInt(input.value, 10) > 1) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const cartItem = button.closest('.cart-item');
      const removeButton = cartItem && cartItem.querySelector('cart-remove-button button');
      if (removeButton) removeButton.click();
    },
    true
  );
})();
